import React from 'react';
import Icon from '../../../components/AppIcon';

const GroupStatistics = ({ statistics, currentLanguage }) => {
  const labels = {
    fr: {
      totalGroups: 'Groupes totaux',
      activeGroups: 'Groupes actifs',
      totalCapacity: 'Capacité totale',
      assignedPilgrims: 'Pèlerins assignés',
      availableSpots: 'Places disponibles',
      totalRevenue: 'Revenu total',
      omraGroups: 'Groupes Omra',
      hajjGroups: 'Groupes Hajj'
    },
    ar: {
      totalGroups: 'إجمالي المجموعات',
      activeGroups: 'المجموعات النشطة',
      totalCapacity: 'السعة الإجمالية',
      assignedPilgrims: 'الحجاج المعينون',
      availableSpots: 'الأماكن المتاحة',
      totalRevenue: 'إجمالي الإيرادات',
      omraGroups: 'مجموعات العمرة',
      hajjGroups: 'مجموعات الحج'
    }
  };

  const l = labels?.[currentLanguage];

  const stats = [
    {
      label: l?.totalGroups,
      value: statistics?.totalGroups,
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: l?.activeGroups,
      value: statistics?.activeGroups,
      icon: 'CheckCircle2',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: l?.totalCapacity,
      value: statistics?.totalCapacity,
      icon: 'Users',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      label: l?.assignedPilgrims,
      value: statistics?.assignedPilgrims,
      icon: 'UserCheck',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    },
    {
      label: l?.availableSpots,
      value: statistics?.availableSpots,
      icon: 'UserPlus',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: l?.totalRevenue,
      value: `${statistics?.totalRevenue?.toLocaleString('fr-MA')} MAD`,
      icon: 'DollarSign',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg shadow-warm p-4 hover:shadow-warm-md transition-smooth"
        >
          <div className="flex items-center gap-3">
            <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center flex-shrink-0`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="caption text-muted-foreground mb-1">{stat?.label}</p>
              <p className="text-xl md:text-2xl font-semibold text-foreground data-text truncate">
                {stat?.value}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GroupStatistics;